export enum StepTypeEnum {
  CUSTOMIZE_HOUSE_STEPS = "CustomizeHouseStepsEnum",
  CUSTOMIZE_HOUSE_STEPS_REVIEW_QUOTE = "CustomizeHouseStepsReviewQuoteEnum",
}
